module.exports = __webpack_public_path__ + "static/media/processing.caaec026.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/processing.svg
// module id = 491
// module chunks = 0